import { useIntl } from '@capsicum/common';
import { useAtom } from 'jotai';
import { useCallback, useMemo } from 'react';

import { ncwPrivacyModeAtom } from '../../data-access';

/**
 * This hook is for the NCWalletBalance Mob/Web components
 */
export const useNCWalletBalance = () => {
	const { $t } = useIntl();

	const [privacyMode, setPrivacyMode] = useAtom(ncwPrivacyModeAtom);
	const onTogglePrivacyMode = useCallback(() => setPrivacyMode(!privacyMode), [privacyMode, setPrivacyMode]);

	return {
		intlText: {
			totalBalance: $t('ncWallet.home.totalBalance')
		},
		onTogglePrivacyMode
	};
};

/**
 * This hook is for the TotalBalance which is a sub component of NCWalletBalance component
 * @param {string} balance data prop
 */
export const useNCWalletTotalBalance = (balance?: string) => {
	const [privacyMode] = useAtom(ncwPrivacyModeAtom);

	const balanceOrAsterisk = useMemo(() => {
		const displayBalance = balance || '∗∗∗∗∗∗∗';

		return privacyMode ? '∗'.repeat(displayBalance.length) : displayBalance;
	}, [balance, privacyMode]);

	return {
		balanceOrAsterisk
	};
};
